import icon from "images/icons/icon-public.svg?raw"
import parse from "html-react-parser"

export default function PublicIcon() {
  return (
    <span className="svg-icon">{parse(icon)}</span>
  )
}
